export default __webpack_public_path__ + "static/media/password-back.34d1dc2e.svg";